import type { Plugin } from "@webiny/plugins/types.js";
import type { GraphQLHandlerFactoryParams } from "./graphQLHandlerFactory.js";
import { graphQLHandlerFactory } from "./graphQLHandlerFactory.js";
import { createBaseSchema } from "~/graphql/schema/baseSchema.js";
import { createCmsSchema } from "~/graphql/schema/cms/index.js";

export type CreateGraphQLParams = GraphQLHandlerFactoryParams;
export const createGraphQL = (params: CreateGraphQLParams): Plugin[] => {
    return [createBaseSchema(), createCmsSchema(), ...graphQLHandlerFactory(params)];
};
